// App.jsx
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ProtectedRoute from 'routes/ProtectedRoute';

import MainPage from './pages/main/MainPage';

import LoginPage from './pages/login/LoginPage';
import VendingMachinePage from './pages/vending/VendingMachinePage';
import PaymentPage from './pages/vending/PaymentPage';
import PaymentSuccessPage from './pages/vending/PaymentSuccessPage';

import './App.css';

function App() {
  return (
    <BrowserRouter>
      <Routes>

        <Route path="/login" element={<LoginPage />} />

        <Route path="/admin/*" element={
          <ProtectedRoute>
            <MainPage />
          </ProtectedRoute>
        }
        />

        {/* 3. 사용자 결제/주문 페이지 */}
        <Route path="/pay" element={<VendingMachinePage />} />

        {/* 결제 진행 페이지 */}
        <Route path="/payment" element={<PaymentPage />} />

        {/* 결제 완료 페이지 */}
        <Route path="/success" element={<PaymentSuccessPage />} />

      </Routes>
    </BrowserRouter>
  );
}

export default App;